import { getMainInternshipsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainInternshipsSearchRoutePath';
import { getMainJobsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainJobsSearchRoutePath';
import { getMainOrgSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainOrgSearchRoutePath';

import { FindAJobDropdownData } from './FindAJobDropdownData';

export const findAJobDropdownDataEs: FindAJobDropdownData = {
  triggerText: 'Encuentra empleo',
  triggerHref: getMainJobsSearchRoutePath({ lang: 'es' }),
  search: {
    title: 'Encuentra',
    items: [
      {
        type: 'job',
        icon: 'briefcase',
        title: 'Empleos',
        href: getMainJobsSearchRoutePath({ lang: 'es' }),
      },
      {
        type: 'internship',
        icon: 'sign-path',
        title: 'Pasantías',
        href: getMainInternshipsSearchRoutePath({ lang: 'es' }),
      },
      {
        type: 'org',
        icon: 'building',
        title: 'Organizaciones',
        href: getMainOrgSearchRoutePath({ lang: 'es' }),
      },
    ],
  },
  resources: {
    title: 'Resources',
    items: [
      {
        image: 'illustrations/article-illustration.svg',
        title: 'Desarrollo de carrera',
        description:
          'Herramientas y consejos útiles para construir una carrera profesional con impacto.',
        href: '/es/accion?categories=empleocambiamundo&pq=',
      },
    ],
  },
};
